import { mapReceivement } from 'src/utils/mappers/mapReceivement'
import {
  optionsFor,
  resultToSuccess,
  resultToFailed,
  badgeHeader
} from '../Helper'
import stockApi, { addTokenHeader } from '../StockApi'

export const getAvailableDocks = async (badge, fc) => {
  if (!fc) {
    return resultToFailed({ message: 'FC inválido.' })
  }

  try {
    const response = await stockApi.get(`/v2/dock/available`, {
      params: {
        id_fulfillment_center: fc
      },
      headers: badgeHeader(badge)
    })
    return resultToSuccess(response)
  } catch (error) {
    return resultToFailed(error)
  }
}

export const assignDock = async (badge, dockId) => {
  try {
    const response = await stockApi.put(
      `/v2/dock/${dockId}/assign`,
      {},
      optionsFor(badge)
    )
    return resultToSuccess(response)
  } catch (error) {
    return resultToFailed(error)
  }
}

export const unassignDock = async (dockId) => {
  try {
    const response = await stockApi.post(
      `/v2/auth/logout`,
      {
        dock_id: dockId,
      },
      await addTokenHeader()
    );
    return resultToSuccess(response)
  } catch (error) {
    return resultToFailed(error)
  }
}

export const getCurrentReceivement = async (dockId) => {
  try {
    const response = await stockApi.get(
      `/v2/dock/${dockId}/current-receivement`,
      await addTokenHeader()
    )
    response.data.currentReceivement = mapReceivement(
      response.data.current_receivement
    )
    return resultToSuccess(response)
  } catch (error) {
    return resultToFailed(error)
  }
}

export const assignDockByHash = async (badge, idFulfillmentCenter, hash) => {
  try {
    const response = await stockApi.patch(
      '/v2/dock/hash-assign',
      {
        id_fulfillment_center: idFulfillmentCenter,
        hash
      },
      optionsFor(badge)
    )
    return resultToSuccess(response)
  } catch (error) {
    return resultToFailed(error)
  }
}
